class SystemError extends Error {}

export default SystemError
